import { Alert, Link, Typography } from '@ace-clublabs/shared-component-library';

export const ChangeMembershipBanner = () => {
  return (
    <Alert
      severity="warning"
      icon={false}
      displayCloseButton={false}
      sx={{ maxWidth: '950px !important', width: '100%', marginTop: '1rem' }}
    >
      <Typography variant="b1Regular">
        •{'  '}Changes <strong>will be effective seven (7) days</strong> after full payment is received.
      </Typography>
      <Typography variant="b1Regular">
        •{'  '}For any membership changes or cancellations that cannot be done online, please call{' '}
        <Link variant="b2Regular" href="tel:+18447861615" target="_blank">
          1-844-786-1615.
        </Link>
      </Typography>
    </Alert>
  );
};
